'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../styleInject.js');

var css_248z = ".SMSOptinForm-module_smsOptinFormContainer__F3gmO{display:grid;grid-template-columns:repeat(12,1fr);grid-gap:.5rem;gap:.5rem}";
var styles = {"smsOptinFormContainer":"SMSOptinForm-module_smsOptinFormContainer__F3gmO"};
styleInject["default"](css_248z, '47d6a877-4492-41b7-be11-ee44938feb86');

exports["default"] = styles;
